import React, {useRef, useState} from 'react'
import * as Yup from "yup";
import { connect } from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";

import { FORM, REQUIRED } from "../../components/i18n/i18n";
import { FL_DESCRIPTION, FL_TERM } from "../../components/i18n/formLabels";
import { PH_DESCRIPTION, PH_TERM } from "../../components/i18n/placeHolders";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit, GenericTableButton
} from "../../components/buttons/buttonsActions";
import { save, update } from "../../redux/actions/xooka/glossaryActions"
import { setViewMode } from "../../redux/actions/generalActions/mainActions";
import { setForm, setItem, clearState} from "../../redux/actions/generalActions/formActions";
import {TT_HISTORY} from "../../components/i18n/toolTips";
import {LogHistoryModal} from "../../components/logHistory/logHistoryModal";

const GlossaryForm = props => {
    const { editMode, disableInputs, saveSuccess, domainObject } = props.formState;

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        term: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            term: domainObject?.term || '',
            description: domainObject?.description || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = { item:{ ...data } }

        window.localStorage.setItem('updateGlossary', '1')

        if(!editMode)
            return props.save(dataRequest);
        else {
            let id = domainObject.id;

            dataRequest.item.id = domainObject?.id
            return props.update(id, dataRequest)
        }
    };

    const resetForm = () => {
        props.clearState();
        reset();
    }

    const beginEdit = () => props.setForm(true, false, false);

    const returnToList = () => {
        props.setViewMode("LIST");
        props.setItem(null);
        props.setForm();
    }

    return ( <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
            {
                editMode && <div className="float-right">
                    <GenericTableButton
                        toolTip={TT_HISTORY}
                        icon={'fa-clock'}
                        permission={'search'}
                        onClick={showHistory}
                    />
                </div>
            }
        </CardTitle>
        <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_TERM }</Label>
                            <Input
                                type="text"
                                name="term"
                                placeholder={ PH_TERM }
                                innerRef={register}
                                disabled={disableInputs}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{FL_DESCRIPTION}</Label>
                            <Input
                                type="textarea"
                                name="description"
                                placeholder={PH_DESCRIPTION}
                                innerRef={register}
                                disabled={ disableInputs }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <CardBody className="border-top">
                    {
                        saveSuccess ?
                            <div className="float-right">
                                <ButtonNew onClick={ resetForm }/>
                                <ButtonEdit onClick={ beginEdit }/>
                                <ButtonCancel onClick={ returnToList }/>
                            </div>
                            : <div className="float-right">
                                <ButtonSubmit/>
                                <ButtonCancel onClick={ returnToList }/>
                            </div>
                    }
                </CardBody>
            </Form>
        </CardBody>
        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </Card>)
}

const mapStateToProps = state => ({
    formState: state.formProps,
})
const mapActionsToProps = ({
    save,
    update,
    setForm,
    setItem,
    clearState,
    setViewMode,
})

export default connect(mapStateToProps, mapActionsToProps)(GlossaryForm)
